import { BaseModel } from '../../_base/crud';

export class WorkOS extends BaseModel {
  id: number;
  company_id: number;
  company_name: string;
  connection_id: string;
  organization_id: string;
  workos_client_id: string;
  workos_api_key: string;
  redirect_url: string;

  clear(): void {
    this.id = 0;
    this.company_id = 0;
    this.company_name = null;
    this.connection_id = null;
    this.organization_id = null;
    this.workos_client_id = null;
    this.workos_api_key = null;
    this.redirect_url = null;
  }
}
